import { ArrayOps } from '../lift';
/**
 * Removes the item found at the specified index.
 */
export function removeAt(index) {
    var result = this.value().slice();
    result.splice(index, index < 0 ? 0 : 1);
    return new ArrayOps(result);
}
ArrayOps.prototype.removeAt = removeAt;
